import './image-text.scss';

export default () => {

};
